export const EXPERIMENT_NAMES = {
  MOJ_SENTRY: {
    name: "moj_sentry_v3",
    control: "control",
    variants: {
      VARIANT1: "variant-1",
    },
  },
};
